import React from "react";
import { formatBook } from "../../../utils/formatOdds";
import { RefCard } from "./ThreeCardJCardsOverlay";

const CARD_TOKENS = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];

/**
 * 3 Cards Judgement bet area in the reference markup (inside .casino-detail):
 *   .threecardj-container > per market (feed `sub`, subtype 3cardj, by sr):
 *     .threecardj-bl-box.back|lay > .threecardj-title (b nat + .casino-book)
 *       + .threecardj-cards[.suspended] (.threecardj-odds b · .casino-cards 13 × card A..K ·
 *         .casino-min-max.text-right span = remark split on "|" [i])
 */
export default function ThreeCardJBetTable({ markets = [], remark = "", exposures = {}, onBetClick }) {
  const texts = String(remark || "").split("|");
  const getExposure = (name) => {
    if (!name) return 0;
    const v = exposures[name] ?? exposures[String(name).toLowerCase()];
    return v != null ? Number(v) || 0 : 0;
  };

  return (
    <div className="threecardj-container">
      {markets.map((s, i) => {
        const suspended = s?.gstatus !== "OPEN";
        const exp = getExposure(s?.nat);
        const side = i === 0 ? " back" : i === 1 ? " lay" : "";
        return (
          <div key={s?.sid ?? i} className={`threecardj-bl-box${side}`}>
            <div className="threecardj-title">
              <b>{s?.nat}</b> <span className={`casino-book ${exp > 0 ? "book-green" : "book-red"}`}>{formatBook(exp)}</span>
            </div>{" "}
            <div
              className={`threecardj-cards${suspended ? " suspended" : ""}`}
              onClick={() => !suspended && onBetClick?.(s?.b, s?.nat, null, s)}
            >
              <div className="threecardj-odds text-center">
                <b>{s?.b}</b>
              </div>{" "}
              <div className="casino-cards text-center mt-1">
                {CARD_TOKENS.map((c) => (
                  <div key={c} className="casino-card-item">
                    <div className="card-image">
                      <RefCard card={c} />
                    </div>
                  </div>
                ))}
              </div>{" "}
              <div className="casino-min-max text-right">
                <span>{texts[i]}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
